import { useContext } from 'react';

import PageHeader from '@/components/PageHeader';
import PersonInsurancePolicy from '@/components/PersonInsurancePolicy';
import { Color } from '@/constants/color';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import PersonContext from '@/pages/Person/PersonContext';
import Button from '@/ui/components/Button';
import Container from '@/ui/components/Container';

const PersonInsurance = () => {
  const {
    person: { id: personId, insurance_policies }
  } = useContext(PersonContext);
  const { navigateToVOBList } = useNavigateToPage();

  return (
    <Container type="page">
      <div className="flex items-center justify-between">
        <PageHeader headingText="Insurance policies" />
        <Button
          ariaLabel="All VOBs for this member"
          color={Color.WHITE}
          size="sm"
          onClick={() => navigateToVOBList({ member_id: personId })}>
          All VOBs
        </Button>
      </div>
      {insurance_policies.map((insurancePolicy) => (
        <PersonInsurancePolicy key={insurancePolicy.id} insurancePolicy={insurancePolicy} />
      ))}
    </Container>
  );
};

export default PersonInsurance;
